import React, { Fragment } from "react";
import { styled } from "../../../../stitches.config";

import QuoteIcon from "../../../../assets/img/natemat/quote.svg";
// bizon
import quoteIcon from '../../../../redesign/assets/icons/quote-icon.svg';
import quoteDotsIcon from "../../../../redesign/assets/icons/quote-dots-icon.svg";

export default class Quote extends React.Component {
  render() {
    const html = this.props.content;
    if (html) {
      return (

        <QuoteBizonWrapper>
          <QuoteBizonBox>
            <StyledQuoteIcon></StyledQuoteIcon>
            <div className='quote' dangerouslySetInnerHTML={{ __html: html }}>

            </div>
          </QuoteBizonBox>
          <StyledQuoteDotsIcon></StyledQuoteDotsIcon>
        </QuoteBizonWrapper>
      );
    } else {
      return (
        <Fragment>
          <QuoteWrapper>{this.props.children}</QuoteWrapper>
        </Fragment>
      );
    }
  }
}

const QuoteWrapper = styled("div", {
  borderTop: "1px solid #B2B2B2",
  borderBottom: "1px solid #B2B2B2",
  margin: "17px 0px 17px 52px",
  padding: "10px 20px 10px 0",
  position: "relative",
  "&:before": {
    display: "block",
    position: "absolute",
    top: "9px",
    left: "-45px",
    content: "''",
    width: "34px",
    height: "24px",
    background: `url("${QuoteIcon}") no-repeat center center`,
    backgroundSize: "32px auto"
  },
  "@bp4": {
    margin: "17px 0px 17px 80px",
    borderTop: "none",
    borderBottom: "none",
    borderLeft: "1px solid #B2B2B2",
    padding: "10px 20px",
    "&:before": {
      left: "-80px",
      width: "50px",
      height: "27px",
      backgroundSize: "50px auto"
    }
  },
  "p": {
    margin: "0",
    "em": {
      color: "#232323",
      fontFamily: '"Playfair Display"',
      fontSize: "19px",
      lineHeight: "23px"
    }
  },
  ".author-header": {
    marginBottom: "12px",
    display: "flex",
    flexDirection: "column",
    ".avatar": {
      display: "none"
    },
    ".name": {
      fontSize: "16px",
      fontWeight: 500,
      letterSpacing: "-0.3px",
      lineHeight: "19px",
      paddingBottom: "6px"
    },
    ".about": {
      color: "#B2B2B2",
      fontSize: "14px",
      letterSpacing: "-0.3px",
      lineHeight: "16px"
    },
    ".more": {
      display: "none"
    }
  }
});

const QuoteBizonBox = styled("div", {
  maxWidth: "840px",
  margin: "0 auto",
  color: "#FFF !important"
});

const QuoteBizonWrapper = styled("div", {
  background: "#131212",
  width: "100%",
  maxWidth: "840px",
  padding: "45px 64px 48px 24px",
  position: "relative",
  margin: "40px auto 32px auto",
  "@bp4": {
    padding: "72px 168px 72px 64px",
    margin: "88px auto 80px auto"
  },
  ".quote": {
    height: "auto",
    display: "flex",
    flexDirection: "column-reverse",
    "p": {
      fontFamily: "$grotesk",
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "24px",
      color: "#FFFFFF",
      "@bp4": {
        fontSize: "24px",
        lineHeight: "30px",
        fontWeight: 700
      },
      "em": {
        fontStyle: "normal !important"
      }
    }
  },
  ".author-header": {
    marginTop: "24px",
    display: "flex",
    flexDirection: "column",
    "@bp4": {
      marginTop: "32px"
    },
    ".avatar": {
      display: "none"
    },
    ".name": {
      fontFamily: "$grotesk",
      fontSize: "16px",
      fontWeight: 500,
      letterSpacing: "-0.3px",
      lineHeight: "19px",
      paddingBottom: "6px",
      "@bp4": {
        fontWeight: 600,
        lineHeight: "24px",
        letterSpacing: "0px"
      }
    },
    ".about": {
      color: "#B2B2B2",
      fontSize: "14px",
      letterSpacing: "-0.3px",
      lineHeight: "16px"
    },
    ".more": {
      display: "none"
    }
  }
});

const StyledQuoteIcon = styled("div", {
  width: "64px",
  height: "58px",
  backgroundImage: `url("${quoteIcon}")`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  margin: "0 0 30px 0",
  "@bp4": {
    width: "88px",
    height: "82px",
    margin: "0 0 40px 0",
    backgroundSize: "82px"
  }
});

const StyledQuoteDotsIcon = styled("div", {
  position: "absolute",
  right: "0",
  bottom: "0",
  width: "40px",
  height: "137px",
  flexShrink: 0,
  backgroundImage: `url("${quoteDotsIcon}")`,
  backgroundSize: "cover",
  "@bp4": {
    width: "80px",
    height: "278px"
  }
});